/* eslint-disable react-hooks/exhaustive-deps */
import { FacebookOutlined } from '@ant-design/icons';
import { useAppDispatch, useBusinessState } from '@core/configureStore';
import { integrateToService } from '@core/features';
import { enqueueNotification, openModal } from '@core/features';
import { fetchFacebookSelectedPage } from '@core/features/business/thunks';
import { useHeroApiService } from '@core/hooks';
import { FacebookPage } from '@core/models';
import { Button, Popover } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';

type Props = {};

const ConnectFacebookLocation = (props: Props) => {
  const dispatch = useAppDispatch();
  const heroApiService = useHeroApiService();
  const { integration } = useBusinessState();
  const [loading, setLoading] = useState<boolean>(false);
  const selectedPage = useMemo<FacebookPage | undefined>(
    () => integration.facebook_page,
    [integration]
  );

  const handleFetchSelectedPage = async () => {
    setLoading(true);
    try {
      await dispatch(fetchFacebookSelectedPage());
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleLogoutFacebookPage = async () => {
    setLoading(true);
    try {
      await heroApiService.unselectFacebookPage();
      dispatch(
        integrateToService({
          platform: 'facebook_page',
          profile: undefined,
        })
      );
      await dispatch(
        enqueueNotification({
          name: 'Successfully disconnect page',
          description: 'Disconnect page sucessfully',
          type: 'Success',
        })
      );
    } catch (error) {
      await dispatch(
        enqueueNotification({
          name: 'Failed to disconnect page',
          description: 'Disconenct page unsucessfully',
          type: 'Error',
        })
      );
    }
    setLoading(false);
  };

  const handleSelectPage = () => {
    dispatch(
      openModal({
        modalName: 'selectFacebookPagesModal',
      })
    );
  };

  useEffect(() => {
    const init = async () => {
      await handleFetchSelectedPage();
    };
    init();
  }, []);

  return selectedPage ? (
    <Popover
      trigger={'click'}
      content={<Button onClick={handleLogoutFacebookPage}>Disconnect</Button>}>
      <Button loading={loading} type="primary">
        <FacebookOutlined /> Location Page: {selectedPage.name}
      </Button>
    </Popover>
  ) : (
    <Button loading={loading} onClick={handleSelectPage}>
      <FacebookOutlined /> Select Facebook page
    </Button>
  );
};

export default ConnectFacebookLocation;
